import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./App.css";
import Apping from "./Apping";
import { Provider } from "react-redux";
import { store } from "./Client/REDUX/Store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {/* <RouterProvider router={router} /> */}
    {/* wrap redux around our app */}
    <Provider store={store}>
      <Apping />
    </Provider>
  </React.StrictMode>
);
